<template>
	<div class="sign_wrap">
		<div class="sign_header">
			<div class="sign_top">
				<div class="sign_back" @click="$router.back()"></div>
				<div class="sign_tit">{{$t('index.sign')}}</div>
				<div class="sign_day_num">
					<span>{{$t('sign.sign_day_num')}}</span>
					<span class="day_font">{{running_days}}</span>
					<span>{{$t('sign.days')}}</span>
				</div>
				<div class="sign_btn" :class="isSign?'over':''" @click="signBtn">
					<span v-if="isSign">{{$t('sign.success')}}</span>
					<span v-else>{{$t('sign.signIn')}}</span>
				</div>
			</div>
		</div>
		<div class="sign_main">
			<div class="sign_content">
				<div class="sign_gird">
					<div class="sign_item">
						<div class="val"><span></span>{{signData.reward_num}}</div>
						<div class="label">{{$t('sign.cash')}}</div>
					</div>
					<div class="sign_item">
						<div class="val">{{running_days}}</div>
						<div class="label">{{$t('sign.signDays')}}</div>
					</div>
				</div>
				<div class="calendar_box">
					<div class="cd_tit">
						<div class="calendar_prev">
						</div>
						<p>{{year}}{{$t('utils.year')}}{{month}}{{$t('utils.month')}}</p>
						<div class="calendar_next"></div>
					</div>
					<div class="calendar_header">
						<div class="block">{{$t('sign.seven')}}</div>
						<div class="block">{{$t('sign.one')}}</div>
						<div class="block">{{$t('sign.two')}}</div>
						<div class="block">{{$t('sign.three')}}</div>
						<div class="block">{{$t('sign.four')}}</div>
						<div class="block">{{$t('sign.five')}}</div>
						<div class="block">{{$t('sign.six')}}</div>
					</div>
					<div class="body">
						<div v-for="num in placeholderEleCount" :key="'place_day_' + num" class="block"></div>
						<div v-for="day,idx in allDays" class="block" :key="'day_' + idx">
							<span :class="day.is_signin==1?'signs':''">{{idx+1}}</span>
							<!-- <i :class="day.is_signin==1?'signs':''"></i> -->
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="sign_gift wrap_box">
			<p class="title">{{$t('sign.rewardToday')}}</p>
			<div class="coupon_box tick_bg3" v-if="signData.reward_type == 1">
				<div class="left_money">
					<div class="tick_money"><span>{{$t('utils.moneyMark')}} </span>{{signData.reward_num}}</div>
					<div class="tit">{{$t('sign.cash')}}</div>
				</div>
				<div class="right_content center">
					<p class="tick_tit">{{$t('sign.cash')}}</p>
					<p class="tick_time">{{$t('sign.addToBalance')}}</p>
				</div>
			</div>
		</div> -->
			<div class="series_sign">
				<p class="title">{{$t('sign.cumulative')}}</p>
				<div class="series_box">
					<sign-process custom-class="process" :data="reward_set_list" :active="Number(running_days)" />
				</div>
			</div>
			<p class="tips">{{$t('sign.note2')}}</p>
			<div class="sign_mask" v-show="signShow">
				<div class="sign_inner">
					<div class="sign_inner_content">
						<div class="sign_pic">
							<img src="../images/sign/pop.png" alt="">
							<div class="sign_success">{{$t('sign.success')}}</div>
						</div>
						<div class="award_tit">
							<p class="award_tips">{{$t('sign.get')}}{{award_tips}}</p>
							<p class="award_num">{{$t('utils.money')}}{{award_num}}</p>
						</div>
						<div class="basic_btn sign_button" @click="signShow = false"><span>{{$t('utils.submit')}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const BIG_MONTH = [1, 3, 5, 7, 8, 10, 12]
	const SMALL_MONTH = [4, 6, 9, 11]

	function getDaysFromCurrentMonth(year, month) {
		if (BIG_MONTH.indexOf(month) !== -1) {
			return 31
		}

		if (SMALL_MONTH.indexOf(month) !== -1) {
			return 30
		}

		if ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) {
			return 29
		}

		return 28
	}

	function getWeekdayOfMonth(year, month) {
		const fistDate = new Date(year, month - 1, 1)
		return fistDate.getDay()
	}

	function isObject(obj) {
		return Object.prototype.toString.call(obj) === '[object Object]'
	}

	function getRewardSetList(obj) {
		if (isObject(obj)) {
			return Object.keys(obj).map(key => {
				return {
					value: obj[key].value,
					type: obj[key].type,
					day: key,
					id: obj[key].id,
					getstatus: obj[key].getstatus
				}
			})
		}

		return []
	}

	import Vue from 'vue';
	import SignProcess from '../../components/signProcess'
	import Fetch from '../../utils/fetch';
	import {
		Dialog
	} from 'vant';

	export default {
		name: "jz",
		components: {
			SignProcess
		},
		data() {
			return {
				data: {},
				signData: {},
				running_days: 0,
				show_down: false,
				title: '',
				isSign: false,
				placeholderEleCount: 0,
				allDays: 0,
				reward_set_list: [],
				award_tips: '',
				award_num: '',
				signShow: false,
				year: null, //年份
				month: null, //月份
			};
		},
		created() {
			this.$parent.footer('user', false);
			let today = new Date()
			this.year = today.getFullYear()
			this.month = today.getMonth() + 1
		},
		mounted() {
			this.init();
		},
		methods: {
			signBtn() {
				Fetch('/user/sign').then(r => {
					this.signShow = true;
					this.running_days = r.data.days;
					this.isSign = true;
					this.award_tips = this.$t('sign.cash');
					this.award_num = r.data.reward_num;
					this.init();
				})
			},
			init() {

				Fetch('/user/sign_log').then(r => {
					this.allDays = r.data.date_list;
				})

				// 累计奖励列表
				Fetch('/user/sign_reward').then(r => {
					var reward_set = {};
					r.data.reward_list.forEach(item => {
						reward_set[item.days] = {
							type: item.reward_type == 2 ? 'djq' : 'hb',
							value: item.reward_num,
							getstatus: item.can_draw,
							id: item.id
						}
					})
					this.running_days = r.data.signin_days
					this.isSign = r.data.isSign
					this.reward_set_list = getRewardSetList(reward_set)
					this.signData = r.data.today_reward
				})


				const year = today.getFullYear()
				const month = today.getMonth() + 1


				// const days = getDaysFromCurrentMonth(year, month)
				this.title = `${year}-${month}`
				// this.allDays = getDaysFromCurrentMonth(year, month)
				this.placeholderEleCount = getWeekdayOfMonth(year, month);

			}
		}
	};
</script>

<style lang="less" scoped>
    .basic_wrap {
        background-color: #F1F4F6;
        min-height: 100vh;
        padding-bottom: 20px;
    }

	.sign_header {
		width: 100%;
		height: 220px;
        background: linear-gradient(135deg, #4F46E5 0%, #6366f1 100%);
		position: relative;
		overflow: hidden;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;


		.sign_back {
			width: 30px;
			height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
			position: absolute;
			top: 15px;
			left: 10px;
            
            &::before {
                content: '';
                width: 10px;
                height: 10px;
                border-top: 2px solid #fff;
                border-left: 2px solid #fff;
                transform: rotate(-45deg);
            }
		}

		.sign_tit {
			width: 100%;
			height: 60px;
			line-height: 60px;
			font-size: 16px;
			color: #fff;
			font-weight: bold;
			text-align: center;
		}

		.sign_day_num {
			margin-top: 10px;
			display: flex;
			justify-content: center;
			align-items: baseline;

			span {
				font-size: 14px;
				color: rgba(255,255,255,0.9);
			}

			.day_font {
				font-size: 32px;
				font-weight: bold;
				color: #fff;
				margin: 0 8px;
			}
		}

		.sign_btn {
			text-align: center;
			width: 120px;
			height: 36px;
			background: #fff;
			border-radius: 20px;
			margin: 20px auto 0;
			font-size: 14px;
            font-weight: bold;
			line-height: 36px;
			color: #4F46E5;
            box-shadow: 0 4px 10px rgba(0,0,0,0.1);
            transition: all 0.3s;
            
            &:active {
                transform: scale(0.95);
            }

			&.over {
				color: #999;
                background: #f5f5f5;
                box-shadow: none;
			}
		}
	}

    .sign_main {
		position: relative;
		top: -30px;
		z-index: 30;
	}

    .sign_content {
		padding: 0 15px;
	}

	.sign_gird {
		background-color: #fff;
		border-radius: 12px;
		height: 80px;
		display: flex;
		align-items: center;
		padding: 10px 0;
		margin-bottom: 15px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);

		.sign_item {
			height: 100%;
			text-align: center;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;

			.val {
				color: #4F46E5;
				font-size: 20px;
				font-weight: bold;
			}

			.label {
				font-size: 13px;
				margin-top: 8px;
				color: #666;
			}
		}

		.sign_item + .sign_item {
            position: relative;
            
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 20%;
                height: 60%;
                width: 1px;
                background-color: #f5f5f5;
            }
		}
	}

	.calendar_box {
		width: 100%;
		padding: 15px 0;
		background: #fff;
		box-shadow: 0 2px 10px rgba(0,0,0,0.02);
		border-radius: 12px;

		.cd_tit {
			font-size: 16px;
            font-weight: bold;
			line-height: 30px;
			color: #333;
			height: 40px;
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: center;
            margin-bottom: 10px;

			div {
				width: 30px;
				height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                
                &::before {
                    content: '';
                    width: 8px;
                    height: 8px;
                    border-top: 2px solid #ccc;
                    border-left: 2px solid #ccc;
                }
			}

			.calendar_prev::before {
                transform: rotate(-45deg);
			}

			.calendar_next::before {
                transform: rotate(135deg);
			}

			p {
				margin: 0 30px;
			}
		}

		.calendar_header {
			display: flex;
			flex-wrap: nowrap;
			align-items: center;
			width: 100%;
			padding: 0 15px;
			height: 34px;
			font-weight: bold;
			line-height: 34px;

			.block {
				width: 14.28%;
				font-size: 13px;
				color: #666;
				text-align: center;
			}
		}

		.body {
			display: flex;
			flex-wrap: wrap;
			padding: 0 15px;

			.block {
				text-align: center;
				line-height: 34px;
				position: relative;
				height: 34px;
				margin-top: 10px;
				width: 14.28%;
				font-size: 14px;
				color: #333;
                font-weight: 500;

				span {
					position: absolute;
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
					z-index: 3;
                    display: flex;
                    align-items: center;
                    justify-content: center;
				}

				.signs {
					color: #fff;
				}

				.signs::after {
					width: 28px;
					height: 28px;
					content: '';
                    background: #4F46E5;
                    border-radius: 50%;
					position: absolute;
					top: 50%;
					left: 50%;
					z-index: -1;
					transform: translate(-50%, -50%);
                    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.3);
				}
			}
		}
	}

	.series_sign {
		width: 100%;
		position: relative;
        padding: 0 15px;
        margin-top: 20px;

		.title {
			height: 45px;
			line-height: 45px;
			font-size: 16px;
			font-weight: bold;
			color: #333;
		}
	}

    .series_box {
		background-color: #fff;
		border-radius: 12px;
		padding: 20px 15px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);
	}

	.tips {
		width: 100%;
		padding: 20px 25px;
		font-size: 12px;
		color: #999;
		line-height: 1.6;
	}

	.sign_mask {
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;

		.sign_inner {
			width: 300px;
			background-color: #fff;
			border-radius: 16px;
            overflow: hidden;
            animation: popIn 0.3s ease;

			.sign_inner_content {
                padding: 0;
			}

			.sign_pic {
				position: relative;
				text-align: center;
                background: linear-gradient(135deg, #4F46E5 0%, #6366f1 100%);
                padding: 30px 0;

				img {
					width: 80px;
					height: auto;
                    margin-bottom: 15px;
				}

				.sign_success {
					font-size: 20px;
                    font-weight: bold;
					color: #ffffff;
					text-align: center;
				}
			}

			.award_tit {
				font-weight: bold;
				text-align: center;
				line-height: 1;
				margin-top: 30px;
				margin-bottom: 30px;

				.award_tips {
					font-size: 15px;
					color: #666;
					margin-bottom: 15px;
				}

				.award_num {
					font-size: 36px;
					color: #4F46E5;
				}
			}

			.sign_button {
				margin: 0 20px 20px;
				height: 44px;
                background: #4F46E5;
                color: #fff;
                border-radius: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
				font-size: 16px;
                font-weight: bold;
                cursor: pointer;
                
                &:active {
                    opacity: 0.9;
                }
			}
		}
	}
    
    @keyframes popIn {
        from { transform: scale(0.8); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
    }
</style>
